export default __webpack_public_path__ + "static/media/c4.dbc1b5ce.svg";